// ----------------------------------------------------------------------
// https://www.convertsimple.com/convert-markdown-to-html/

export const jobContent = `
<h5 id="one">Job Description</h5>
<p>Occaecati est et illo quibusdam accusamus qui. Incidunt aut et molestiae ut facere aut. Est quidem iusto praesentium excepturi harum nihil tenetur facilis. Ut omnis voluptates nihil accusantium doloribus eaque debitis.</p>
<h5 id="two">Key Responsibilities</h5>
<ul>
  <li>Working with agency for design drawing detail, quotation and local production.</li>
  <li>Produce window displays, signs, interior displays, floor plans and special promotions displays.</li>
  <li>Change displays to promote new product launches and reflect festive or seasonal themes.</li>
  <li>Planning and executing the open/renovation/ closing store procedure.</li>
  <li>Follow‐up store maintenance procedure and keep updating SKU In &amp; Out.</li>
  <li>Monitor costs and work within budget.</li>
  <li>Liaise with suppliers and source elements.</li>
</ul>
<h5 id="three">Why You'll Love Working Here</h5>
<ul>
  <li>Working with agency for design drawing detail, quotation and local production.</li>
  <li>Produce window displays, signs, interior displays, floor plans and special promotions displays.</li>
  <li>Change displays to promote new product launches and reflect festive or seasonal themes.</li>
  <li>Planning and executing the open/renovation/ closing store procedure.</li>
  <li>Follow‐up store maintenance procedure and keep updating SKU In &amp; Out.</li>
  <li>Monitor costs and work within budget.</li>
  <li>Liaise with suppliers and source elements.</li>
</ul>
`;

export const brandsName = [
  'airbnb',
  'dropbox',
  'facebook',
  'google',
  'heroku',
  'lenovo',
  'microsoft',
  'netflix',
  'slack',
  'spotify',
  'tripadvisor',
  'vimeo',
];

// ----------------------------------------------------------------------

export const jobTitle = [
  'Marketing Coordinator',
  'Medical Assistant',
  'Web Designer',
  'Dog Trainer',
  'President of Sales',
  'Nursing Assistant',
  'Corporate Data Officer',
  'Dynamic Quality Technician',
  'Relational Mobility Technician',
  'Senior Web Engineer',
  'Dynamic Markets Administrator',
  'Chief Research Analyst',
  'Internal Paradigm Synergist',
  'Relational Accountability Liason',
  'Regional Brand Associate',
  'Interactive Creative Supervisor',
];

// ----------------------------------------------------------------------

export const jobCategories = [
  'Design',
  'Marketing',
  'Management',
  'Healthcare',
  'Development',
  'Engineering',
  'HR & Recruiting',
  'Garage services',
  'Sport and leisure',
  'Computing and ICT',
  'Financial services',
  'Design, arts and crafts',
  'Construction and building',
  'Social sciences and religion',
  'Science, mathematics and statistics',
  'Transport, distribution and logistics',
];

// ----------------------------------------------------------------------

export const tourName = [
  'Italian Delights - 12 Days',
  'Best of Sicily - 8 Days (Small Group Tour)',
  'Gourmet Journey of Emilia Romagna - 7 Days',
  'Adventure in Iceland',
  'Fire and Ice (6 Days)',
  'Iceland Northern Lights & Golden Circle — Plus',
  'New Tour Egypt (2 for 1) Tour in 5* Hotel & Nile Cruise',
  'Egypt Luxury Guided Tour W/Nile Cruise & Air',
  'London with Day trip to Paris',
  'Great Britain Christmas - 7 Days',
  'Essential Turkey Small Group',
  'Istanbul to Cappadocia',
  '6 Nights in Greece',
  'Death Valley Day Tour from Las Vegas- Small Groups Tour',
  'National Parks Winter Tour',
  'National Parks Tour 3 Days Small Group Tour from Las Vegas',
];

// ----------------------------------------------------------------------

export const courseTitle = [
  'Design Masterclass Course',
  'Fitness For Beginners (2020)',
  'The Secrets To Teaching Online',
  'Learn How To Create A Course Online And Level Up Your Career',
  'Create A Course Online Masterclass',
  'Learn How To Create A Course Online And Level Up Your Career',
  '2021 Complete Python Bootcamp From Zero to Hero in Python',
  'Machine Learning A-Z™: Hands-On Python & R In Data Science',
  'The Complete Digital Marketing Course - 12 Courses in 1',
  'SEO beginners : how I get 1,000 visitors a day with SEO',
  'Mega Digital Marketing Course A-Z: 12 Courses in 1 + Updates',
  'Copywriting: Fundamentals For Beginners',
  'Modern Copywriting: Writing copy that sells in 2021',
  'Copywriting secrets - How to write copy that sells',
  'Instagram Marketing 2021: Complete Guide To Instagram Growth',
  'Python for Finance and Algorithmic Trading with QuantConnect',
];

// ----------------------------------------------------------------------

export const blogTitle = [
  'Apply These 7 Secret Techniques To Improve Event',
  'Believing These 7 Myths About Event Keeps You From Growing',
  "Don't Waste Time! 7 Facts Until You Reach Your Event",
  'How 7 Things Will Change The Way You Approach Event',
  "Event Awards: 7 Reasons Why They Don't Work & What You Can Do About It",
  "Event Doesn't Have To Be Hard. Read These 7 Tips",
  'Event Is Your Worst Enemy. 7 Ways To Defeat It',
  'Event On A Budget: 7 Tips From The Great Depression',
  'Knowing These 7 Secrets Will Make Your Event Look Amazing',
  'Master The Art Of Event With These 7 Tips',
  'My Life, My Job, My Career: How 7 Simple Event Helped Me Succeed',
  'Take Advantage Of Event - Read These 7 Tips',
  'The Next 7 Things You Should Do For Event Success',
  'The Time Is Running Out! Think About These 7 Ways To Change Your Event',
  'The 7 Best Things About Event',
  'The 7 Biggest Event Mistakes You Can Easily Avoid',
  'The 7 Most Successful Event Companies In Region',
  'Think Your Event Is Safe? 7 Ways You Can Lose It Today',
  "Thinking About Event? 7 Reasons Why It's Time To Stop!",
  '7 Places To Get Deals On Event',
  'Best Event Android Apps',
  'Best Event Tips You Will Read This Year',
  'Best 30 Tips For Event',
  'Should Fixing Event Take 30 Steps?',
  'The A - Z Of Event',
  'The Next 30 Things To Immediately Do About Event',
  'The Ultimate Guide To Event',
  'Top 30 Funny Event Quotes',
  'Top 30 Quotes On Event',
  'Top 7 Lessons About Event To Learn Before You Hit 30',
  'Top 7 Ways To Buy A Used Event',
  '30 Best Ways To Sell Event',
  '30 Ideas For Event',
  '30 Lessons About Event You Need To Learn Before You Hit 40',
  '30 Methods Of Event Domination',
  '30 Things To Do Immediately About Event',
  '30 Tips To Grow Your Event',
  '30 Ways To Avoid Event Burnout',
  '30 Ways To Improve Event',
  'How To Make More Event By Doing Less',
];

// ----------------------------------------------------------------------

export const sentence = [
  'Assumenda nam repudiandae rerum fugiat vel maxime.',
  'Quis veniam aut saepe aliquid nulla.',
  'Reprehenderit ut voluptas sapiente ratione nostrum est.',
  'Error ut sit vel molestias velit.',
  'Quo quia sit nihil nemo doloremque et.',
  'Autem doloribus harum vero laborum.',
  'Tempora officiis consequuntur architecto nostrum autem nam adipisci.',
  'Voluptas sunt magni adipisci praesentium saepe.',
  'Ea architecto quas voluptates voluptas earum illo est vel rem.',
  'Ipsum expedita reiciendis ut.',
  'Architecto vel voluptatibus alias a aut non maxime ipsa voluptates.',
  'Reiciendis enim officiis cupiditate eaque distinctio laudantium modi similique consequatur.',
  'Ab autem consequatur itaque mollitia ipsum cupiditate error repudiandae nobis.',
  'Distinctio architecto debitis eligendi consequatur unde id modi accusantium possimus.',
  'At ut voluptate accusantium.',
  'Repudiandae ut qui veritatis sint.',
  'Laboriosam blanditiis quo sed et qui esse ipsam necessitatibus sed.',
  'Et molestiae et excepturi maxime omnis.',
  'Sint dolorem quam eum magnam.',
  'Rerum ut iusto iste quam voluptatem necessitatibus.',
  'Et quam in.',
  'Fugit esse tenetur.',
  'Dolorem dolor porro nihil cupiditate molestiae deserunt ut.',
  'Omnis beatae eos eius aut molestias laboriosam laborum et optio.',
  'Ut veniam quam assumenda ut voluptatibus ducimus accusamus.',
  'Quos dignissimos neque omnis reiciendis voluptatem ducimus.',
  'Laboriosam quia ut esse.',
  'Sit reiciendis nihil qui molestias et.',
  'Facilis cupiditate minima ratione quaerat omnis velit non ex totam.',
  'Provident sint esse voluptatem voluptas eveniet est.',
  'Molestias consequatur ea facilis.',
  'Tempora voluptatibus autem ut ut porro quae delectus dolorum.',
  'Et consequatur amet nemo ducimus voluptatem placeat voluptas.',
  'Modi iste atque hic voluptas sit quis deleniti quas consequatur.',
  'Omnis est aliquid odio mollitia aliquid ex.',
  'Officia possimus veniam quod molestias.',
  'Mollitia inventore recusandae provident aut.',
  'Numquam ullam beatae possimus.',
  'Fuga velit cupiditate ex culpa odio aut ut.',
  'Vero corrupti nam voluptatum excepturi est et.',
];

// ----------------------------------------------------------------------

export const description = [
  'Occaecati est et illo quibusdam accusamus qui. Incidunt aut et molestiae ut facere aut. Est quidem iusto praesentium excepturi harum nihil tenetur facilis. Ut omnis voluptates nihil accusantium doloribus eaque debitis.',
  'Atque eaque ducimus minima distinctio velit. Laborum et veniam officiis. Delectus ex saepe hic id laboriosam officia. Odit nostrum qui illum saepe debitis ullam. Laudantium beatae modi fugit ut. Dolores consequatur beatae nihil voluptates rem maiores.',
  'Rerum eius velit dolores. Explicabo ad nemo quibusdam. Voluptatem eum suscipit et ipsum et consequatur aperiam quia. Rerum nulla sequi recusandae illum velit quia quas. Et error laborum maiores cupiditate occaecati.',
  'Et non omnis qui. Qui sunt deserunt dolorem aut velit cumque adipisci aut enim. Nihil quis quisquam nesciunt dicta nobis ab aperiam dolorem repellat. Voluptates non blanditiis. Error et tenetur iste soluta cupiditate ratione perspiciatis et. Quibusdam aliquid nam sunt et quisquam non esse.',
  'Nihil ea sunt facilis praesentium atque. Ab animi alias sequi molestias aut velit ea. Sed possimus eos. Et est aliquid est voluptatem.',
  'Non rerum modi. Accusamus voluptatem odit nihil in. Quidem et iusto numquam veniam culpa aperiam odio aut enim. Quae vel dolores. Pariatur est culpa veritatis aut dolorem.',
  'Est enim et sit non impedit aperiam cumque animi. Aut eius impedit saepe blanditiis. Totam molestias magnam minima fugiat.',
  'Unde a inventore et. Sed esse ut. Atque ducimus quibusdam fuga quas id qui fuga.',
  'Eaque natus adipisci soluta nostrum dolorem. Nesciunt ipsum molestias ut aliquid natus ut omnis qui fugiat. Dolor et rem. Ut neque voluptatem blanditiis quasi ullam deleniti.',
  'Nam et error exercitationem qui voluptate optio. Officia omnis qui accusantium ipsam qui. Quia sequi nulla perspiciatis optio vero omnis maxime omnis ipsum. Perspiciatis consequuntur asperiores veniam dolores.',
  'Perspiciatis nulla ut ut ut voluptates totam consectetur eligendi qui. Optio ut cum. Dolorum sapiente qui laborum. Impedit temporibus totam delectus nihil. Voluptatem corrupti rem.',
  'Distinctio omnis similique omnis eos. Repellat cumque rerum nisi. Reiciendis soluta non ut veniam temporibus. Accusantium et dolorem voluptas harum. Nemo eius voluptate dicta et hic nemo. Dolorem assumenda et beatae molestias sit quo mollitia quis consequatur.',
  'Sed ut mollitia tempore ipsam et illum doloribus ut. Occaecati ratione veritatis explicabo. Omnis nam omnis sunt placeat tempore accusantium placeat distinctio velit.',
  'Eum illo dicta et perspiciatis ut blanditiis eos sequi. Ea veritatis aut et voluptas aut. Laborum eos quia tempore a culpa.',
  'Aut quos quae dolores repudiandae similique perferendis perferendis earum laudantium. Facere placeat natus nobis. Eius vitae ullam dolorem.',
  'Vero dolorem et voluptatem fugit tempore a quam iure. Fuga consequatur corrupti sunt asperiores vitae. Libero totam repellendus animi debitis illum et sunt officia.',
  'Cupiditate illum officiis id molestiae. Numquam non molestiae aliquid et natus sed hic. Alias quia explicabo sed corrupti sint. Natus in et odio qui unde facilis quia. Est sit eius laboriosam aliquid non aperiam quia quo corporis.',
  'Et a ab. Optio aspernatur minus tempora amet vitae consectetur inventore cumque. Sed et omnis. Aspernatur a magnam.',
  'Ipsum omnis et. Quia ea et autem tempore consequuntur veniam dolorem officiis. Ipsa dicta et ut quidem quia doloremque. Sequi vitae doloremque temporibus. Deserunt incidunt id aperiam itaque natus. Earum sit eaque quas incidunt nihil.',
  'Quae consequatur reiciendis. Consequatur non optio. Eaque id placeat. Commodi quo officia aut repudiandae reiciendis tempore voluptatem et. Ut accusamus qui itaque maxime aliquam. Fugit ut animi molestiae porro maiores.',
  'Modi hic asperiores ab cumque quam est aut. Voluptas atque quos molestias. Ut excepturi distinctio ipsam aspernatur sit.',
  'Sunt totam facilis. Quam commodi voluptatem veniam. Tempora deleniti itaque fugit nihil voluptas.',
  'Ipsam aliquam velit nobis repellendus officiis aut deserunt id et. Nihil sunt aut dolores aut. Dolores est ipsa quia et laborum quidem laborum accusamus id. Facilis odit quod hic laudantium saepe omnis nisi in sint. Sed cupiditate possimus id.',
  'Magnam non eveniet optio optio ut aliquid atque. Velit libero aspernatur quis laborum consequatur laudantium. Tempora facere optio fugit accusantium ut. Omnis aspernatur reprehenderit autem esse ut ut enim voluptatibus.',
  'Ipsam vel molestiae dolorem iure molestiae. Ut qui cumque et sint recusandae modi nulla. Vel rerum tempore similique autem enim voluptatem dolores facilis. Qui delectus recusandae magnam.',
  'Fugiat molestias distinctio enim nobis rerum. Perspiciatis adipisci corrupti quas sed ab sunt nostrum. Quibusdam reiciendis ratione dolores vitae fuga exercitationem asperiores maxime voluptate. Minus et ea delectus quia ullam est. Exercitationem iusto libero. Et aut dolore reprehenderit et saepe sint modi.',
  'Ex neque aut voluptatem delectus eum deserunt voluptate. Ut quam placeat et. Et impedit tenetur illum aut consequatur quia. Autem sed dolorem non ad aspernatur illum dignissimos beatae. Earum iusto aut rem aut. Facere ea alias enim quo assumenda.',
  'Quis sint recusandae quasi corporis et fugit. Omnis voluptatum id laborum qui. Assumenda animi quia eum et facere fuga. Ab et sint molestiae et voluptatum nostrum est.',
  'Est quis numquam recusandae alias porro magni. Incidunt quis aut necessitatibus nam ea dolores cumque. Quis dolorum veniam.',
  'Corporis magnam non. Ut voluptates pariatur et. Quis tenetur mollitia et necessitatibus et. Perferendis error velit aut.',
  'Eos ex accusantium possimus aut quae. Omnis dolorum velit. Sapiente quia dolore ea assumenda voluptatem exercitationem sed consequuntur. Eveniet et molestiae ipsa harum quidem soluta quo. Consequatur ad sunt sed numquam odio eveniet.',
  'Ut sit et provident vero vero voluptatem distinctio. Cumque sit error qui et. Ea architecto ipsum occaecati sed alias eum vel. Officia tempore architecto autem vel veniam. Minus modi commodi ad consequatur similique ut. Tenetur tempore eum.',
  'Quibusdam in cum voluptatem consequatur rerum. Qui eum assumenda nemo maiores veniam quae. Ipsa occaecati et provident. Quas similique deserunt doloremque placeat natus.',
  'Voluptates et earum fugiat molestiae distinctio. Aut sapiente quas dolores et. Quo et dolor velit et iure consequatur ut in amet. Repellendus aut sequi animi inventore nesciunt itaque.',
  'Sit a tempore dicta provident molestiae. Necessitatibus blanditiis voluptatum. Magnam esse animi in qui veritatis quibusdam recusandae adipisci possimus. Tenetur dolores ipsum.',
  'Neque id sunt amet modi expedita aut libero aut in. Minima dolore praesentium quia quas et pariatur numquam. In ut sequi nemo velit iste minima aliquam. Neque ut tenetur consequuntur sint nemo unde. Magni nesciunt omnis illo optio. Molestias eum exercitationem aut harum odit.',
  'Modi quia laboriosam qui ad aut. Fugit quisquam earum distinctio officia est fugit quos. Iure repellat distinctio veritatis voluptate amet ratione repudiandae.',
  'Impedit perferendis vel quis ratione. Id aut id officia. Illum fuga saepe provident voluptate eligendi provident. Et nostrum maxime magni. Nobis cumque id magni in iste earum.',
  'Dolor numquam maiores praesentium dolorem nihil minus praesentium rem dolorem. Est rerum placeat. Numquam sed magni aliquam laborum enim facere ducimus.',
  'In sint enim nam et itaque et qui. Molestiae a iusto quidem quia temporibus id quia eaque eius. Quis quia consectetur saepe vero et molestias. Rem minima accusamus vitae adipisci molestiae unde voluptate consequatur molestiae. Rerum exercitationem quisquam vitae.',
];

// ----------------------------------------------------------------------
